import type { MessageDescriptor } from 'react-intl';

import { BillingPlanIds, isPremiumPlan, isStandardPlan, isStarterPlan } from '../../../../../../../enums/billing-plan-ids';

import { messages } from './messages';

export const getPlanDescriptionMessage = (billingPlanId: string | number | null | undefined): MessageDescriptor | null => {
  if (billingPlanId == null) return null;

  const parsed = typeof billingPlanId === 'number' ? billingPlanId : parseInt(String(billingPlanId), 10);

  if (parsed === BillingPlanIds.Free2025Q2) return messages.freeDescription;
  if (isStarterPlan(billingPlanId)) return messages.starterDescription;
  if (isStandardPlan(billingPlanId)) return messages.standardDescription;
  if (isPremiumPlan(billingPlanId)) return messages.premiumDescription;

  return null;
};
